import * as React from 'react';

const VersionPage: React.FC = () => (
  <div>
    Version: {VERSION}
    <br />
    Hash: {COMMITHASH}
    <br />
  </div>
);

export { VersionPage };
